export const fragenFahrgestellNummer = [
  {
    question: "Was ist die Fahrgestellnummer (FIN)?",
    answer: (
      <>
        <p>
          Die Fahrgestellnummer (FIN), international auch als VIN (Vehicle
          Identification Number) bekannt, ist eine einzigartige 17-stellige
          Kombination aus Zahlen und Buchstaben. Sie dient zur eindeutigen
          Identifikation eines Fahrzeugs und enthält wichtige Informationen wie
          Hersteller, Modell, Baujahr und Produktionsstandort. Die FIN wird vom
          Hersteller festgelegt und ist dauerhaft am Fahrzeug angebracht, meist
          auf der Windschutzscheibe, im Türrahmen oder im Motorraum. Sie ist
          auch in den Fahrzeugpapieren eingetragen und unverzichtbar für
          Fahrzeugregistrierungen, Versicherungen und technische Abfragen.
        </p>
      </>
    ),
  },
  {
    question: "Ist FIN dasselbe wie VIN?",
    answer: (
      <>
        <p>
          Ja, die FIN (Fahrzeug-Identifizierungsnummer) und die VIN (Vehicle
          Identification Number) sind dasselbe. Die FIN ist die deutsche
          Bezeichnung, während VIN international gebräuchlich ist. Beide
          bezeichnen die gleiche 17-stellige Nummer, die jedes Fahrzeug weltweit
          eindeutig identifiziert.
        </p>
      </>
    ),
  },
  {
    question: "Warum ist die Fahrgestellnummer meines Autos wichtig?",
    answer: (
      <>
        <p>
          Die Fahrgestellnummer (FIN) ist wichtig, weil sie jedes Fahrzeug
          weltweit eindeutig identifiziert. Sie enthält wertvolle Informationen
          wie den Hersteller, das Modell, das Baujahr und technische Details.
          Die FIN spielt eine zentrale Rolle bei:
        </p>
        <ul className="AV-Fragen-ul">
          <li>
            <strong>Fahrzeugregistrierung: </strong>Versicherer nutzen die FIN,
            um das Fahrzeug genau zuzuordnen.
          </li>
          <li>
            <strong>Versicherungen: </strong>Dein Fahrzeug zum bestmöglichen
            Preis verkaufen.
          </li>
          <li>
            <strong>Fahrzeughistorie: </strong>Mit der FIN können Vorbesitzer,
            Unfälle oder Reparaturen nachvollzogen werden.
          </li>
          <li>
            <strong>Diebstahlschutz: </strong>Die FIN wird verwendet, um
            gestohlene Fahrzeuge in Datenbanken zu identifizieren.
          </li>
        </ul>
        <p>
          Durch die FIN bleibt dein Auto eindeutig erkennbar und seine Historie
          nachvollziehbar, was besonders beim Kauf oder Verkauf eines Fahrzeugs
          wichtig ist.
        </p>
      </>
    ),
  },
  {
    question: "Ist die Fahrgestellnummer in allen Ländern gleich?",
    answer: (
      <>
        <p>
          Ja, die Fahrgestellnummer (FIN) folgt weltweit einer einheitlichen
          Struktur, die durch die Norm ISO 3779 geregelt ist. Diese Norm legt
          fest, dass jede FIN aus 17 Zeichen besteht und bestimmte Positionen
          festgelegte Informationen enthalten müssen.
        </p>
        <p>
          Während die Struktur international gleich ist, können kleine
          Unterschiede je nach Hersteller oder Land auftreten, beispielsweise in
          der Art der Codierung oder der Reihenfolge bestimmter Daten. Dennoch
          bleibt die FIN überall standardisiert und sorgt so für eine eindeutige
          Identifikation von Fahrzeugen weltweit.
        </p>
      </>
    ),
  },
  {
    question: "Wo finde ich die Fahrgestellnummer an meinem Fahrzeug?",
    answer: (
      <>
        <p>Du findest die Fahrgestellnummer (FIN) an mehreren Stellen:</p>
        <ul className="AV-Fragen-ul">
          <li>
            <strong>Am Fahrzeug: </strong>
            <br />
            <br />
            <ul className="AV-Fragen-ul">
              <li>
                Unten an der Windschutzscheibe, auf der Fahrerseite (von außen
                sichtbar).
              </li>
              <li>
                Im Türrahmen der Fahrerseite, meist auf einem Aufkleber oder
                Typenschild.
              </li>
              <li>Im Motorraum, auf der Karosserie oder einem Schild.</li>
              <li>
                Am Armaturenbrett oder der Lenksäule, nahe dem Fahrersitz.
              </li>
            </ul>
          </li>
          <li>
            <strong>In den Fahrzeugdokumenten: </strong>
            <br />
            <br />
            <ul className="AV-Fragen-ul">
              <li>Im Zulassungsschein</li>
              <li>
                Im Türrahmen der Fahrerseite, meist auf einem Aufkleber oder
                Typenschild.
              </li>
              <li>Im Typenschein </li>
            </ul>
          </li>
        </ul>
        <p>
          Falls du die FIN nicht findest, hilft ein Blick ins Fahrzeughandbuch
          oder eine Nachfrage beim Hersteller.
        </p>
      </>
    ),
  },

  {
    question: "Ist es sicher, meine Fahrgestellnummer weiterzugeben?",
    answer: (
      <>
        <p>
          Ja, es ist in der Regel sicher, deine Fahrgestellnummer (FIN)
          weiterzugeben. Sie ist sichtbar am Fahrzeug angebracht und dient zur
          Identifikation, beispielsweise bei Werkstätten, Versicherungen oder
          bei einem Fahrzeugverkauf.
        </p>
        <p>
          Allerdings solltest du die FIN nur an vertrauenswürdige Personen oder
          Unternehmen weitergeben, da sie verwendet werden kann, um
          Informationen über dein Fahrzeug abzurufen. Achte darauf, sie nicht in
          unseriösen Online-Portalen oder Foren zu veröffentlichen, um möglichen
          Missbrauch zu vermeiden. Wenn du unsicher bist, prüfe die Seriosität
          des Anbieters, bevor du deine FIN teilst.
        </p>
      </>
    ),
  },
  {
    question: "Kann ich die Fahrgestellnummer meines Autos ändern?",
    answer: (
      <>
        <p>
          Nein, die Fahrgestellnummer (FIN) kann nicht geändert werden. Sie wird
          vom Hersteller bei der Produktion des Fahrzeugs vergeben und dauerhaft
          in die Karosserie geprägt oder graviert. Die FIN dient als
          unveränderliche Identifikation und ist rechtlich geschützt.
        </p>
      </>
    ),
  },
  {
    question: "Was kann man mit der Fahrgestellnummer herausfinden?",
    answer: (
      <>
        <p>
          Mit der Fahrgestellnummer (FIN) kannst du eine Vielzahl von
          Informationen über dein Fahrzeug abrufen, darunter:
        </p>
        <ul className="AV-Fragen-ul">
          <li>
            Technische Daten: Details zu Motor, Getriebe, Ausstattung, Farbe und
            Baujahr.
          </li>
          <li>
            Fahrzeughistorie: Anzahl der Vorbesitzer, Zulassungen, Unfälle und
            Reparaturen.
          </li>
          <li>
            Diebstahlüberprüfung: Ob das Fahrzeug als gestohlen gemeldet ist,
            anhand von nationalen und internationalen Datenbanken.
          </li>
          <li>
            Rechtliche Informationen: Offene Finanzierungen, Leasingverträge
            oder mögliche Sperren.
          </li>
        </ul>

        <p>
          Diese Daten können bei Fahrzeugherstellern, in offiziellen Datenbanken
          oder über VIN-Decoder-Dienste abgerufen werden. Besonders beim Kauf
          eines Gebrauchtwagens hilft die FIN, Transparenz über den Zustand und
          die Historie des Fahrzeugs zu schaffen.
        </p>
      </>
    ),
  },
  {
    question:
      "Welche Informationen erhalte ich mit der kostenlosen Fahrgestellnummer überprüfen?",
    answer: (
      <>
        <p>
          Mit einer kostenlosen Überprüfung der Fahrgestellnummer kannst du bei
          Autoeinfachlos bereits viele nützliche Informationen erhalten, wie zum
          Beispiel:
        </p>
        <ul className="AV-Fragen-ul">
          <li>
            <strong>Basisinformationen zum Fahrzeug: </strong>Details wie
            Herstellungsjahr, Produktionsland und ursprünglicher Listenpreis.
          </li>
          <li>
            <strong>Ausstattung deines Fahrzeugs: </strong>Eine Übersicht aller
            Serien- und Sonderausstattungen, die das Fahrzeug ab Werk hatte.
          </li>
          <li>
            <strong>Aktueller Marktwert: </strong>Eine Schätzung des aktuellen
            Marktwerts, basierend auf den neuesten Marktdaten und ähnlichen
            Fahrzeugen am Gebrauchtwagenmarkt.
          </li>
        </ul>
        <p>
          Die kostenlose Prüfung liefert dir eine solide Grundlage, um mehr über
          dein Fahrzeug oder ein Gebrauchtfahrzeug zu erfahren.
        </p>
      </>
    ),
  },
  {
    question: "Kann ich die Fahrzeughistorie anhand der FIN überprüfen?",
    answer: (
      <>
        <p>
          Ja, mit der Fahrgestellnummer (FIN) kannst du die Fahrzeughistorie
          einfach und schnell überprüfen. Häufig sind diese Berichte
          kostenpflichtig und liegen im Preisbereich von 15 bis 20 Euro. Sie
          bieten dir detaillierte Einblicke in die Vergangenheit des Fahrzeugs,
          wie zum Beispiel:
        </p>
        <ul className="AV-Fragen-ul">
          <li>
            <strong>Anzahl der Vorbesitzer: </strong>Erfahre, wie oft das
            Fahrzeug den Besitzer gewechselt hat.
          </li>
          <li>
            <strong>Unfallhistorie: </strong>Prüfe, ob das Fahrzeug in Unfälle
            verwickelt war und welche Schäden eventuell repariert wurden.
          </li>
          <li>
            <strong>Service- und Wartungshistorie: </strong>Einsicht in
            durchgeführte Inspektionen und Reparaturen (je nach Datenbank).
          </li>
          <li>
            <strong>Registrierungen: </strong>Informationen zu Erstzulassung und
            früheren Anmeldungen, auch in anderen Ländern.
          </li>
        </ul>

        <p>
          Dienste wie CARFAX, autoDNA oder Herstellerdatenbanken bieten diese
          Berichte häufig an.
        </p>
      </>
    ),
  },
  {
    question: "Kann ich überprüfen, ob ein Fahrzeug gestohlen wurde?",
    answer: (
      <>
        <p>
          Ja, du kannst mit der Fahrgestellnummer (FIN) überprüfen, ob ein
          Fahrzeug als gestohlen gemeldet wurde.
        </p>
      </>
    ),
  },
];
